import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);
class ChartBlock {
	constructor() {
		this.gridElTranslation = document.querySelector('.tmpl-grid-data').dataset.translation;
	}
	
	init = async () => {
		this.getData();
	}

	getData = async () => {
		let endpoint = '';
		switch (this.gridElTranslation) {
			case 'default':
			  endpoint = 'global-metrics/v1/data';
			  break;
			case 'dach':
			  endpoint = 'global-metrics/v1/data-dach';
			  break;
			case 'benelux':
			  endpoint = 'global-metrics/v1/data-benelux';
			  break;
			default:
				endpoint = 'global-metrics/v1/data';
		}

		const response = await fetch(window.apiSettings.restAPI.base + endpoint);
		const dataJson = await response.json();
		
		$('.btn-grid').on('click', () => {
			this.structureData(dataJson);
			$('.btn-grid').css('display', 'none');
			$('.button-wrapper').append('<div class="ui__spin-loader"></div>')
			// This set timeout function is in place for visual user experience only
			setTimeout(function() {
				$('.btn-grid').css('display', 'inline-flex');
				$('.ui__spin-loader').remove();
			}, 250);
		})
		this.structureData(dataJson);
	}

	structureData = (data) => {
		const charts = document.querySelectorAll('.grid-chart-wrapper');
		const chartQuestions = [];
		const multResData = {};
		let allValue = '';

		switch (this.gridElTranslation) {
			case 'default':
				allValue = 'All';
				break;
			case 'dach':
				allValue = 'Alle';
				break;
			case 'benelux':
				allValue = 'Alle soorten';
				break;
			default:
				allValue = 'All';
		}
		
		charts.forEach(c => {
			chartQuestions.push(c.dataset.question);
			multResData[c.dataset.question] = {};
		})

		const staffingTypeFilter = $('#staffingType option:selected').text();
		const regionNormFilter = $('#regionNormalized option:selected').text();

		for (var i=0; i<data.length; i++) {
			for (var j=0; j<chartQuestions.length; j++) {
				if (data[i][chartQuestions[j]].length && (staffingTypeFilter === allValue ? data[i].staffingType.length : data[i].staffingType === staffingTypeFilter) && 
				(regionNormFilter === allValue ? data[i].regionNormalized.length : data[i].regionNormalized === regionNormFilter)) {
					multResData[chartQuestions[j]][data[i][chartQuestions[j]]] ? multResData[chartQuestions[j]][data[i][chartQuestions[j]]]++ : multResData[chartQuestions[j]][data[i][chartQuestions[j]]] = 1;
				}
			}	
		}
		
		this.renderData(multResData, chartQuestions);
	}


	renderData = (data, chartQuestions) => {
		for (var i=0; i<chartQuestions.length; i++) {
			const pieLabelData = [];
			const valueData = [];
			
			const barData = {
				labels: [''],
				datasets: [
				]
			};
			let valueTotal = 0;
			const valuePercentages = [];
			
			const chartType = $(`#chartWrapper-${chartQuestions[i]}`).data('type');
			
			Object.entries(data[chartQuestions[i]]).forEach(d => {
				
				pieLabelData.push(d[0]);
				
				valueData.push(d[1]);
				valueTotal += d[1];

				barData.datasets.push({'label': d[0], 'data': [1]});

			});
			
			const backgroundColorArray = [ '#BC46C6', '#654CB1', '#4377B5', '#499BC1', '#63ABA6', '#C9DC6C', '#DFB0E3', '#9E8FCE', '#8DC1D8', '#9CCBC8', '#DDE8A2' ]; 
		
			
			valueData.forEach(v => {
				valuePercentages.push(Math.round((v/valueTotal)*100));
			})
			
			for (var j=0; j<barData.datasets.length; j++) {
				barData.datasets[j].data = [valuePercentages[j]];
				barData.datasets[j].backgroundColor = [backgroundColorArray[j]];
			}
			let dataByChartType = {};

			if (chartType === 'pie') {
				dataByChartType = {
					labels: pieLabelData,
					datasets: [
						{
							backgroundColor: backgroundColorArray,
							data: valuePercentages,
							label: 'label'
						}
					]
				};
			} else if (chartType === 'bar') {
				dataByChartType = barData;
			}
			
			
			$(`#${chartQuestions[i]}`).remove();
			$(`#chartDiv-${chartQuestions[i]}`).prepend(`<canvas id="${chartQuestions[i]}"></canvas>`);
			
			$(`#legend-container-${chartQuestions[i]}`).remove();
			$(`#chartDiv-${chartQuestions[i]}`).append(`<div id="legend-container-${chartQuestions[i]}" class="legend"></div>`);
			
			const containerID = `legend-container-${chartQuestions[i]}`;

			const getOrCreateLegendList = (chart, id) => {
				const legendContainer = document.getElementById(id);
				let listContainer = legendContainer.querySelector('ul');
				
				if (listContainer) {
					listContainer.remove();
				}
				
				listContainer = document.createElement('ul');
				listContainer.style.margin = 0;
				listContainer.style.padding = 0;
				
				legendContainer.appendChild(listContainer);
				
				return listContainer;
			};
			
			const htmlLegendPlugin = {
				id: 'htmlLegend',
				afterUpdate(chart, args, options) {
					const ul = getOrCreateLegendList(chart, options.containerID);

					const items = chart.options.plugins.legend.labels.generateLabels(chart);

					if (chartType === 'pie' || chartType === 'bar') {
						items.forEach(item => {
							const li = document.createElement('li');
							li.classList.add('legend-list-item');
							
							// Color box
							const boxSpan = document.createElement('span');
							boxSpan.style.background = item.fillStyle;
							boxSpan.style.borderColor = item.strokeStyle;
							boxSpan.style.borderWidth = item.lineWidth + 'px';
									
									
							// Text
							const textContainer = document.createElement('p');
							textContainer.style.color = item.fontColor;
							textContainer.style.margin = 0;
							textContainer.style.padding = 0;
							textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
									
							const text = document.createTextNode(item.text);
							textContainer.appendChild(text);
							
							li.appendChild(boxSpan);
							li.appendChild(textContainer);
							ul.appendChild(li);
						});
					}
				}
			};
			const chart = new Chart(
				document.getElementById(`${chartQuestions[i]}`), {
					type: chartType,
					data: dataByChartType,
					options: {
						plugins: {
							tooltip: {
								enabled: false
							},
							datalabels: {
								anchor: 'end',
								backgroundColor: '#ffffff',
								borderColor: '#d6d6d6',
								borderRadius: 11,
								borderWidth: 1,
								clip: false,
								clamp: true,
								color: '#202945',
								display: 'auto',
								font: {
									family: 'Montserrat',
									size: '11',
									weight: '500'
								},
								formatter: function(value) {
									return value + '%';
								},
								padding: {
									top: 4,
									right: 10,
									bottom: 3,
									left: 10
								}
							},
							htmlLegend: {
								// ID of the container to put the legend in
								containerID: containerID
							  },
							legend: {
								display: false
							}
						},
						layout: {
							padding: 20
						},
						responsive: true,
						animation: {
							animateScale: true,
							animateRotate: true
						},
						indexAxis: 'y'
					},
					plugins: [htmlLegendPlugin]
				}		
			);
		}	
	}
}

export default ChartBlock;


	
  